import {
  GARLIC_CRUST_SEASONING_CODE,
  PARMESAN_CRUST_SEASONING_CODE,
  SEASONING_OPTIONS,
} from "constants/crustSeasonings";

const hasSeasoningCode = (seasonings, seasoningCode) => {
  return !!seasonings.find(
    (seasoning) => seasoning.toppingCode === seasoningCode
  );
};

export const getCrustSeasoningOptions = (seasonings) => {
  const hasGarlicSeasoning = hasSeasoningCode(
    seasonings,
    GARLIC_CRUST_SEASONING_CODE
  );
  const hasParmesanSeasoning = hasSeasoningCode(
    seasonings,
    PARMESAN_CRUST_SEASONING_CODE
  );

  const seasoningOptions = [];
  if (hasParmesanSeasoning && hasGarlicSeasoning) {
    seasoningOptions.push(SEASONING_OPTIONS.PARMESAN_GARLIC_CRUST);
  }

  if (hasGarlicSeasoning) {
    seasoningOptions.push(SEASONING_OPTIONS.GARLIC_CRUST);
  }

  if (seasoningOptions.length > 0) {
    seasoningOptions.push(SEASONING_OPTIONS.NO_SEASONING);
  }

  return seasoningOptions;
};
